import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';

// 클라우드 파이어스토어 모듈 가져옴
import {
  firestorePlugin
} from 'vuefire'
// 클라우드 파이어스토어 모듈 사용 준비
Vue.use(firestorePlugin)

// 파이어베이스 앱 객체 모듈 가져오기
import firebase from 'firebase/app'
//import firebase from 'firebase'
import '@/datasources/firebase'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  created() {
    // 익명 계정 생성
    this.$store.dispatch("fnDoAnonymousLogin")

    // 사용자가 로그아웃, 비밀번호 변경 등의 변경을 했을 때 처리
    firebase.auth().onAuthStateChanged(pUserInfo => {
      if (pUserInfo !== null && pUserInfo.isAnonymous == true) {
        // 익명 로그인이 성공함
        // 로그인이 성공하면 스토어에 계정정보 저장
        this.$store.commit('fnSetUser', {
          id: pUserInfo.uid,
          name: 'guest',
          email: 'guest',
          photoURL: null
        })
        console.log("익명 로그인 성공!");
        //router.push('/main') // 로그인 후 화면으로 이동
      } else if (pUserInfo !== null && pUserInfo.isAnonymous == false) {
        // 이미 로그인 되어있었는지 등의 상태를 파악하여 처리함
        store.dispatch('fnDoLoginAuto', pUserInfo)
      }
    })
  },
  render: h => h(App)
}).$mount('#app')